import moment from 'moment-timezone'
import { get } from 'lodash'
import format from 'civic-champs-shared/utils/format'
import activitySources from '../../enum/activitySources'
import { LOG_OTHER_HOURS } from '../../enum/entryMethod'

const emptyCell = (width = '6em') => ({ value: null, display: '', width })

const isFromLogOtherHours = (activity: any) => {
  const source = (activitySources as any)[activity.occurredAtSource]
  return get(source, 'entryMethod', LOG_OTHER_HOURS) === LOG_OTHER_HOURS
}

export const getCheckInDateValue = (timeZone: string) => (activity: any) => {
  const occurredAt = moment.tz(activity.occurredAt, timeZone)
  const date = isFromLogOtherHours(activity) ? occurredAt.clone().startOf('day') : occurredAt

  return { value: date, display: format.date(date), width: '8em' }
}

export const getCheckInTimeValue = (timeZone: string) => (activity: any) => {
  if (isFromLogOtherHours(activity)) {
    return emptyCell()
  }

  const occurredAt = moment.tz(activity.occurredAt, timeZone)

  return { value: occurredAt, display: format.time(occurredAt, false), width: '6em' }
}

export const getCheckOutTimeValue = (timeZone: string) => (activity: any) => {
  if (isFromLogOtherHours(activity)) {
    return emptyCell()
  }

  const checkOut = moment.tz(activity.occurredAt, timeZone).add(activity.hoursVolunteered, 'hours')

  return { value: checkOut, display: format.time(checkOut, false), width: '6em' }
}

export const formatActivityCheckInExportFields = (activity: any) => {
  const fromLogOtherHours = isFromLogOtherHours(activity)
  const occurredAt = moment(activity.occurredAt)
  const checkOut = occurredAt.clone().add(activity.hoursVolunteered, 'hours')

  if (fromLogOtherHours) {
    return {
      checkInDate: format.date(occurredAt.clone().startOf('day')),
      checkInTime: '',
      checkOutDate: '',
      checkOutTime: '',
    }
  }

  return {
    checkInDate: format.date(occurredAt),
    checkInTime: format.time(occurredAt),
    checkOutDate: format.date(checkOut),
    checkOutTime: format.time(checkOut),
  }
}
